export default "__VITE_ASSET__CZwmje01__"